import {useTheme} from '@mui/material';
import {formatAddress, getAddressforMaps} from 'presentation/utils';
import {openGoogleMaps} from 'presentation/modules/booking/shared/utils/openGoogleMaps';
import {Channel} from 'domain/usecases/private/service-points/get-service-points';

export function useServicePointAddress(servicePoint: Channel) {
	const {palette} = useTheme();
	const address = formatAddress({
		state: servicePoint?.cdUf,
		city: servicePoint?.nmCidade,
		number: servicePoint?.nuEndereco,
		address: servicePoint?.dsLogradouro,
		complement: servicePoint?.dsComplemento,
		district: servicePoint?.nmBairro,
		zipCode: servicePoint?.nuCep,
	});
	const formattedAddress = getAddressforMaps(address);
	const handleOpenGoogleMaps = () => openGoogleMaps(formattedAddress?.addressForMaps ?? '');

	return {handleOpenGoogleMaps, address, palette};
}
